import { L, vocabulary } from '../define.js';
/** D577 slice d: risk-severity. */
export const RISK_SEVERITY_VOCABULARIES = [
    vocabulary('common.severity', '@vello/food-risk INCIDENT_SEVERITIES', {
        low: L('Baixa', 'Low', 'Baja', 'Bassa'),
        medium: L('Média', 'Medium', 'Media', 'Media'),
        high: L('Alta', 'High', 'Alta', 'Alta'),
        critical: L('Crítica', 'Critical', 'Crítica', 'Critica'),
    }),
    vocabulary('food_risk.decision', '@vello/food-risk AppealDecision; @vello/food-risk CaseDecision', {
        uphold: L('Manter a decisão', 'Uphold the decision', 'Mantener la decisión', 'Confermare la decisione'),
        overturn: L('Reverter a decisão', 'Overturn the decision', 'Revertir la decisión', 'Annullare la decisione'),
        approve: L('Aprovar', 'Approve', 'Aprobar', 'Approvare'),
    }),
    vocabulary('food_risk.escalation_target', '@vello/food-risk ESCALATION_TARGETS', {
        regulator: L('Órgão regulador', 'Regulator', 'Organismo regulador', 'Autorità di regolamentazione'),
        legal: L('Jurídico', 'Legal', 'Jurídico', 'Ufficio legale'),
        trust_and_safety: L('Confiança e segurança', 'Trust and safety', 'Confianza y seguridad', 'Fiducia e sicurezza'),
    }),
    vocabulary('food_risk.incident_action', '@vello/food-risk INCIDENT_ACTIONS', {
        warn: L('Advertir', 'Warn', 'Advertir', 'Avvertire'),
        suspend_pending_review: L('Suspender até a revisão', 'Suspend pending review', 'Suspender hasta la revisión', 'Sospendere in attesa di revisione'),
    }),
    vocabulary('food_risk.review_state', '@vello/food-risk REVIEW_STATES', {
        OPEN: L('Aberto', 'Open', 'Abierto', 'Aperto'),
        APPROVED: L('Aprovado', 'Approved', 'Aprobado', 'Approvato'),
        OVERTURNED: L('Revertido', 'Overturned', 'Revertido', 'Annullato'),
        APPEALED: L('Em recurso', 'Under appeal', 'En apelación', 'In appello'),
        APPEAL_UPHELD: L('Recurso negado', 'Appeal upheld', 'Apelación mantenida', 'Appello respinto'),
        APPEAL_OVERTURNED: L('Recurso aceito', 'Appeal overturned', 'Apelación aceptada', 'Appello accolto'),
    }),
    vocabulary('food_risk.risk_tier', '@vello/food-risk RISK_TIERS', {
        allow: L('Permitir', 'Allow', 'Permitir', 'Consentire'),
        review: L('Revisar', 'Review', 'Revisar', 'Rivedere'),
        restrict: L('Restringir', 'Restrict', 'Restringir', 'Limitare'),
    }),
    vocabulary('food_risk.signal_source', '@vello/food-risk RISK_SIGNAL_SOURCES', {
        account: L('Conta', 'Account', 'Cuenta', 'Account'),
        payment: L('Pagamento', 'Payment', 'Pago', 'Pagamento'),
        promo_abuse: L('Abuso de promoções', 'Promotion abuse', 'Abuso de promociones', 'Abuso di promozioni'),
        device: L('Aparelho', 'Device', 'Dispositivo', 'Dispositivo'),
        delivery: L('Entrega', 'Delivery', 'Entrega', 'Consegna'),
    }),
    vocabulary('food_risk.subject_kind', '@vello/food-risk SUBJECT_KINDS', {
        account: L('Conta', 'Account', 'Cuenta', 'Account'),
        merchant: L('Lojista', 'Merchant', 'Comercio', 'Esercente'),
        courier: L('Entregador', 'Courier', 'Repartidor', 'Corriere'),
    }),
];
//# sourceMappingURL=risk-severity.js.map